import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DiscountType } from 'src/app/@core/constants';
import { PosProductsModalService } from 'src/app/@core/services/pos-products-modal.service';
import { Discount } from 'src/app/models/discount';
import { ProductCart } from 'src/app/models/product-cart';
import { ProductTableModel } from 'src/app/models/table-models/product-table';
import { ProductsService } from 'src/app/services/products.service';

@Component({
  selector: 'app-pos-add-edit-product-return-manual-modal',
  templateUrl: './pos-add-edit-product-return-manual-modal.component.html',
  styleUrls: ['./pos-add-edit-product-return-manual-modal.component.sass']
})
export class PosAddEditProductReturnManualModalComponent implements OnInit {

  product: ProductCart = new ProductCart();
  confirmAction: (product: ProductCart) => any = () => { };
  productForm: FormGroup = new FormGroup({})
  isEdit: boolean = false;
  constructor(private bsModalRef: BsModalRef, private fb: FormBuilder, private productService: ProductsService, private productsModal: PosProductsModalService) {
    this.productForm = this.fb.group({
      quantity: new FormControl("1", [Validators.required, Validators.min(1)]),
      productCode: new FormControl("", [Validators.required]),
      productDescription: new FormControl("", [Validators.required]),
      serial: new FormControl(""),
      price: new FormControl("1", [Validators.required, Validators.min(1)]),
      discount: new FormControl("0", [Validators.required, Validators.min(0)]),
      tax: new FormControl("", [Validators.required, Validators.min(0)])
    });
  }

  ngOnInit(): void {
  }

  confirm() {
    this.product.productCode = this.productForm.value.productCode;
    this.product.description = this.productForm.value.productDescription;
    this.product.amount = this.productForm.value.quantity;
    this.product.serial = this.productForm.value.serial
    this.product.total = this.productForm.value.price;
    this.product.discountTotal = this.productForm.value.discount;
    if (this.productForm.value.discount > 0) {
      this.product.discount.discountType = DiscountType.ABSOLUTE;
      this.product.discount.discountValue = this.productForm.value.discount;
      this.product.discount.promotionCode = "DEVOLUCIONMANUAL";
    }
    else {
      this.product.discount = new Discount();
    }
    this.confirmAction(this.product);
    this.bsModalRef.hide();
  }
  cancel() {
    this.bsModalRef.hide();
  }
  load() {
    if (this.product.productCode) {
      this.productForm.patchValue({
        quantity: this.product.amount,
        productCode: this.product.productCode,
        productDescription: this.product.description,
        serial: this.product.serial,
        price: this.product.total,
        discount: this.product.discountTotal ?? 0,
        tax: this.product.tax
      });
    }
  }
  async showAddProduct() {
    await this.productsModal.show((product: ProductTableModel) => {
      this.product = this.mapProductoToProductCart(product);
      this.productForm.patchValue({
        productCode: this.product.productCode,
        productDescription: this.product.description,
        price: this.product.total,
        tax: this.product.tax
      })
      this.productsModal.hide();
    });
  }

  private mapProductoToProductCart(product: ProductTableModel) {
    return new ProductCart()
      //.setCode(this.getOrderEntryCode(this.productsCart.content))
      .setCode(this.isEdit ? this.product.code : 0)
      .setProductCode(product.code)
      .setDescription(product.description)
      .setTax(product.tax)
      .setTotal(this.isEdit ? this.product.total : product.total)
      // .setPrice(product.price)
      .setAmount(this.isEdit ? this.product.amount : 1)
      .setTaxCode(product.taxCode)
      .setOriginalTaxCode(product.taxCode)
      .setSerial('')
      .setRequiredSerial(product.requiredSerial)
      .setHasWarranty(product.hasWarranty)
      .setFeatures(product.features)
      .setHasExtraWarrantyAdded(false)
      .setComboSetCode(product.setCorrelative || '')
      .setExtraWarrantyInvoiceCode(product.extraWarrantyInvoiceCode)
      .setExtraWarrantyInvoiceLine(product.extraWarrantyInvoiceLine)
      .setAssociatedOrder(product.associatedOrder)
      .setAssociatedOrderEntry(product.associatedOrderEntry)
      .setAssociatedSerialNumber(product.serialNumber)
      ;

  }

}
